import {Controller} from "@hotwired/stimulus"

export default class extends Controller {



    async save(event: Event) {
        const form = this.element as HTMLFormElement;

        await fetch(form.action, {
            method: 'PATCH',
            body: new FormData(form),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
    }
}

